import { render, staticRenderFns } from "./PanelUserDetail.vue?vue&type=template&id=7b8ad504"
import script from "./PanelUserDetail.vue?vue&type=script&lang=js"
export * from "./PanelUserDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports